import React from "react";
import { Link } from "react-router-dom";
import { useT } from "@/context/I18nContext";
import AuthLayout from "@/components/auth/AuthLayout";
import { User, Building2, ArrowRight } from "lucide-react";

function Choice({ to, icon: Icon, title, body, cta, testId, accent }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group block rounded-3xl bg-white border border-border shadow-card hover:shadow-card-hover hover:-translate-y-0.5 transition-transform p-6 text-left"
    >
      <div className={`h-12 w-12 rounded-2xl ${accent} flex items-center justify-center mb-4`}>
        <Icon className="h-6 w-6" strokeWidth={1.5} />
      </div>
      <div className="font-heading text-xl text-ink-900">{title}</div>
      <p className="text-sm text-ink-500 mt-1.5 leading-relaxed">{body}</p>
      <div className="mt-4 inline-flex items-center gap-1.5 text-sage-600 font-semibold text-sm">
        {cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
      </div>
    </Link>
  );
}

/** Public entry: Personal (B2C, no invite) vs Organisation (B2B professional). */
export default function Entry() {
  const t = useT();
  return (
    <AuthLayout eyebrow={t("b2b.entry.eyebrow")} title={t("b2b.entry.title")} subtitle={t("b2b.entry.subtitle")}
      footer={<span className="text-ink-500">{t("b2b.entry.businessHint")}</span>}>
      <div className="grid grid-cols-1 gap-4" data-testid="entry-choices">
        <Choice to="/login?audience=personal" icon={User} title={t("b2b.entry.personalTitle")} body={t("b2b.entry.personalBody")}
          cta={t("b2b.entry.personalCta")} testId="entry-personal" accent="bg-sage-100 text-sage-700" />
        <Choice to="/login?audience=business" icon={Building2} title={t("b2b.entry.businessTitle")} body={t("b2b.entry.businessBody")}
          cta={t("b2b.entry.businessCta")} testId="entry-business" accent="bg-cream-100 text-ink-700" />
      </div>
    </AuthLayout>
  );
}
